import React from 'react';
import { ArrowRight } from 'lucide-react';

export default function SiteHero() {
  const bgUrl = `${process.env.PUBLIC_URL || ''}/hero-background.png`;
  return (
    <section
      id="home"
      className="relative min-h-[85vh] flex items-center pt-24 pb-16 bg-cover bg-center bg-no-repeat"
      style={{ backgroundImage: `url(${bgUrl})` }}
    >
      <div className="absolute inset-0 bg-slate-900/50" aria-hidden="true" />
      <div className="relative z-10 max-w-6xl mx-auto px-4 sm:px-6 text-center">
        <p className="text-green-300 font-semibold uppercase tracking-wider text-sm mb-4">
          Com esforço e dedicação
        </p>
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight drop-shadow-md">
          Pelo seu bem-estar
        </h1>
        <p className="text-lg sm:text-xl text-slate-200 max-w-2xl mx-auto mb-10 drop-shadow">
          Temos uma vasta gama de soluções que garantem o seu conforto e o bem-estar do seu dia a dia:
          ar condicionado e painéis solares, representando as marcas mais conceituadas no mercado.
        </p>
        <div className="flex flex-wrap justify-center gap-4">
          <a
            href="#contactos"
            className="inline-flex items-center gap-2 px-6 py-3 bg-gestao-primary text-white font-semibold rounded-xl hover:opacity-90 transition-opacity shadow-lg"
          >
            Orçamentos grátis
            <ArrowRight size={18} />
          </a>
        </div>
      </div>
    </section>
  );
}
